import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconVideo = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M15 20H2.98999C1.88999 20 0.98999 19.1 0.98999 18V6C0.98999 4.9 1.88999 4 2.98999 4H15C16.1 4 17 4.9 17 6V7L18.05 5.6C18.33 5.23 18.77 5 19.25 5H21C22.1 5 23 5.9 23 7V17C23 18.1 22.1 19 21 19H19.25C18.78 19 18.33 18.77 18.05 18.4L17 17V18C17 19.1 16.1 20 15 20ZM15 6H2.98999V18.01H15V14.3C15 13.83 15.3 13.41 15.75 13.26C16.2 13.11 16.69 13.26 16.97 13.64L19.5 17.01H21V7H19.5L16.97 10.37C16.69 10.75 16.19 10.9 15.75 10.75C15.3 10.6 15 10.18 15 9.71V6Z" }))));
};
